/** One definition per term — every ⓘ hint reads from here so wording can't drift. */
export const GLOSSARY = {
  seed: "Starting papers. PaperChase follows their citations to find more, and shows them to the grader as examples of a good paper.",
  trawl: "Follow your seeds' citations, references and recommendations to find related papers. Found papers are then graded against your research question.",
  snowball: "A trawl that starts from your highest-scoring found papers instead of your seeds.",
  spotTrawl: "Pull in the specific references cited in passages you highlighted in a seed's PDF.",
  livingLit: "Living Lit — checks for new papers citing your seeds on a schedule and adds them, already scored, for you to triage.",
  triage: "New Living Lit arrivals you haven't kept or dismissed yet.",
  markedRelevant: "Papers you gave a thumbs-up. Your marks also teach the grader what you value.",
  researchQuestion: "PaperChase grades every paper against this.",
  searchTerms: "Used to find starting papers (seeds).",
} as const;

export type GlossaryTerm = keyof typeof GLOSSARY;
